import React, { Component } from "react";

import Home from "../component/Home";
import Login from "../component/login";
import SignUp from "../component/signup";
import Sheduled from '../component/Dashboard/views/shedule'
import SheduledTeacher from '../component/Dashboard/views/shedule  teacher'

import Dashboard from "../component/Dashboard/views/Dashboard";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Profile from '../component/Dashboard/views/profile';
import ProfileTeacher from '../component/Dashboard/views/profile teacher';

import TeacherDashboard from '../component/Dashboard/views/TeacherDashboard';
import TeacherRequestHandle from '../component/Dashboard/views/TeacherRequestHandle'
import Topics from "../component/topics";
class RouterLink extends Component {
  render() {
    return (
      <Routes>
        <Route path="/Dashboard"  element={<Dashboard />} exact />
        <Route path="/Sheduled"  element={<Sheduled />} exact />
        <Route path="/SheduledTeacher"  element={<SheduledTeacher />} exact />

        <Route path="/Profile"  element={<Profile />} exact />
        <Route path="/ProfileTeacher"  element={<ProfileTeacher />} exact />

        <Route path="/topics"  element={<Topics/>} exact />

        <Route path="/TeacherDashboard"  element={<TeacherDashboard />} exact />


        <Route path="/TeacherRequestHandle"  element={<TeacherRequestHandle />} exact />



        <Route path="/signup" element={<SignUp />} exact />

        <Route path="/login" element={<Login/>} exact />

        <Route path="/" element={<Home />} exact />
      </Routes>
    );
  }
}

export default RouterLink;
